/**
 * Utility for parsing and extracting CMS modal content with fallbacks
 */

export interface ModalContentLabels {
  signaturePkgTxt: string;
  genrePkgTxt: string;
  genrePacksLabel: string;
  alsoAvailableInTxt: string;
  availableAsAddonTxt: string;
  shopCta: string;
  genrePacksUrl: string;
  shopCtaAccessibility: string;
}

/**
 * Parses pkgModalContent and extracts all text labels with fallbacks
 * Automatically handles singular/plural based on package counts
 * @param pkgModalContent - CMS content (can be array or object)
 * @param isSatellite - Whether this is satellite variant (affects signaturePkgTxt)
 * @param signatureCount - Number of signature packages (for singular/plural)
 * @param genreCount - Number of genre packages (for singular/plural)
 * @returns Object with all modal text labels
 */
export const parseModalContent = (
  pkgModalContent: any,
  isSatellite: boolean
): ModalContentLabels => {
  // Handle array or object format
  const modalContent = Array.isArray(pkgModalContent) ? pkgModalContent[0] : pkgModalContent;

  let signaturePkgTxt: string;

  if (isSatellite) {
    // Satellite variant
    signaturePkgTxt = modalContent?.signaturePkgTxt || "Available in these Satellite Packages";
  } else {
    // Internet variant
    signaturePkgTxt = modalContent?.signaturePkgTxt || "Available in these Streaming Packages";
  }

  const genrePkgTxt = modalContent?.genrePkgTxt || "Available in these Genre Packs";

  return {
    signaturePkgTxt,
    genrePkgTxt,
    genrePacksLabel: modalContent?.genrePacks?.[0]?.label || "Genre Packs",
    alsoAvailableInTxt: modalContent?.alsoTxt || "Also Available in",
    availableAsAddonTxt: modalContent?.addonTxt || "Available as an Add-on",
    shopCta: modalContent?.genrePacks?.[0]?.cta?.[0]?.label || "Shop",
    genrePacksUrl: modalContent?.genrePacks?.[0]?.cta?.[0]?.targeturl || "/shop/build/configure",
    shopCtaAccessibility: modalContent?.genrePacks?.[0]?.cta?.[0]?.accessibility || "Shop Genre Packs"
  };
};
